export enum PLATFORMS {
  IPHONE = 'iphone',
  IPAD = 'ipad',
  IOS = 'ios',
  ANDROID = 'android'
}
